/**
 * Catálogo de copia en español para la función `community` (foros, hilos, Sala
 * de Leyendas). Las claves reflejan las llamadas a `t('community.*')` en
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityEs = {
  // CommunityPage
  'community.page.seoTitle': 'Comunidad',
  'community.page.seoDescription':
    'Únete a la comunidad de Grymwyrd: foros, teorías sobre la tradición, herramientas para directores, creaciones caseras y la Sala de Leyendas.',
  'community.page.eyebrow': 'La Reunión Oscura',
  'community.page.title': 'Comunidad',
  'community.page.intro':
    'Intercambia tácticas, teoriza sobre la lore, comparte creaciones caseras y ascende hacia el canon. Cada mensaje que publiques te otorga monedas y reputación en el crepúsculo eterno.',
  'community.page.loading': 'Convocando a los fieles…',
  'community.page.forumCategories': 'Categorías de Foros',
  'community.page.categoryStats': '{threads} hilos · {posts} mensajes',
  'community.page.recentActivity': 'Actividad Reciente',
  'community.page.liveFeed': 'feed en directo',
  'community.page.recentEmpty':
    'Los foros guardan silencio esta noche. Abre un debate para despertar a los muertos.',
  'community.page.hallOfLegends': 'Sala de Leyendas',
  'community.page.hallBlurb': 'Los mayores contribuyentes y los personajes que forjaron en canon.',
  'community.page.enterTheHall': 'Entra en la Sala',
  'community.page.playerSpotlights': 'Destacados de Jugadores',
  'community.page.summoningLegends': 'Invocando leyendas…',
  'community.page.sampleNotice': 'Mostrando contenido de comunidad de muestra mientras despiertan los foros en directo.',

  // FlagButton
  'community.flag.errorQueued':
    'No pudimos contactar con los moderadores en este momento, pero tu denuncia ha sido puesta en cola.',
  'community.flag.ariaLabel': 'Denunciar este mensaje para moderación',
  'community.flag.label': 'Denunciar',
  'community.flag.modalTitle': 'Denuncia a los Guardianes',
  'community.flag.successDelivered':
    'Tu denuncia ha sido entregada a los moderadores. Los Guardianes te dan las gracias.',
  'community.flag.close': 'Cerrar',
  'community.flag.signInNotice':
    'Puedes describir el problema, pero debes estar conectado para que la denuncia llegue a los moderadores.',
  'community.flag.whyFlagging': '¿Por qué denuncias esto?',
  'community.flag.reason.spamOrAdvertising': 'Spam o publicidad',
  'community.flag.reason.harassmentOrAbuse': 'Acoso o abuso',
  'community.flag.reason.spoilersWithoutWarning': 'Spoilers sin advertencia',
  'community.flag.reason.offTopic': 'Fuera de tema',
  'community.flag.reason.otherDescribeBelow': 'Otro (describe abajo)',
  'community.flag.describeIssue': 'Describe el problema',
  'community.flag.detailPlaceholder': 'Cuéntale a los Guardianes qué va mal…',
  'community.flag.cancel': 'Cancelar',
  'community.flag.reporting': 'Denunciando…',
  'community.flag.submitReport': 'Enviar denuncia',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Foros',
  'community.category.seoDescription': 'Discusiones en el foro {name} de Grymwyrd.',
  'community.category.breadcrumb': 'Comunidad',
  'community.category.entityTiedPrefix': 'Tablón vinculado a entidades · los hilos pueden enlazar a',
  'community.category.encyclopediaEntries': 'entradas de la enciclopedia',
  'community.category.sampleNotice': 'Mostrando hilos de muestra mientras despierta el foro en directo.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Sala de Leyendas',
  'community.legends.seoDescription':
    'Los mayores contribuyentes a Grymwyrd y los personajes que forjaron en canon.',
  'community.legends.breadcrumb': 'Comunidad',
  'community.legends.title': 'Sala de Leyendas',
  'community.legends.intro':
    'Aquí se alzan los arquitectos del crepúsculo eterno — los contribuyentes cuyas palabras se convirtieron en ley, y los personajes tan amados que fueron esculpidos en el canon.',
  'community.legends.loading': 'Encendiendo las velas…',
  'community.legends.topContributors': 'Principales Contribuyentes',
  'community.legends.noContributors':
    'Aún no ha surgido ninguna leyenda. Publica, teoriza y crea para reclamar tu lugar.',
  'community.legends.canonizedCharacters': 'Personajes Canonizados',
  'community.legends.noCharacters':
    'Aún no se ha canonizado ningún personaje. El bestiario aguarda su próximo horror.',
  'community.legends.sampleNotice': 'Mostrando leyendas de muestra mientras se consagra la sala en directo.',

  // NestedReplies
  'community.replies.replyBy': 'Respuesta de {author}',
  'community.replies.reply': 'Responder',
  'community.replies.replyToPlaceholder': 'Responder a {author}…',
  'community.replies.unlike': 'No me gusta este mensaje',
  'community.replies.like': 'Me gusta este mensaje',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} reputación',
  'community.spotlight.viewInEncyclopedia': 'Ver {name} en la enciclopedia',

  // PostComposer
  'community.composer.placeholder': 'Añade tu voz a la oscuridad…',
  'community.composer.signInPrompt': 'Conéctate para unirte al debate y ganar monedas por tus palabras.',
  'community.composer.signInToReply': 'Conéctate para responder',
  'community.composer.youFallback': 'Tú',
  'community.composer.saveError':
    'Tu respuesta aún no pudo guardarse en el servidor — se muestra solo localmente.',
  'community.composer.writeReply': 'Escribe una respuesta',
  'community.composer.writePost': 'Escribe un mensaje',
  'community.composer.replyText': 'Texto de respuesta',
  'community.composer.postText': 'Texto del mensaje',
  'community.composer.posting': 'Publicando…',
  'community.composer.postReply': 'Publicar respuesta',
  'community.composer.post': 'Publicar',
  'community.composer.cancel': 'Cancelar',
  'community.composer.coinsPerPost': '+{count} monedas por mensaje',
  'community.composer.coinsEarned': '¡+{count} monedas ganadas por tu mensaje!',

  // ThreadItem
  'community.thread.pinned': 'Hilo fijado',
  'community.thread.byPrefix': 'por',
  'community.thread.repliesTitle': '{count} respuestas',
  'community.thread.likesTitle': '{count} me gusta',
  'community.thread.viewsTitle': '{count} vistas',
  'community.thread.entityEntry': 'entrada de {type}',

  // ThreadList
  'community.threadList.empty':
    'Aquí aún no se ha desatado ninguna discusión. Sé el primero en romper el silencio.',

  // ThreadPage
  'community.threadPage.loading': 'Abriendo el hilo…',
  'community.threadPage.seoDescription': 'Una discusión en los foros de comunidad de Grymwyrd.',
  'community.threadPage.replyCount': '{count} respuestas',
  'community.threadPage.opened': 'abierto {time}',
  'community.threadPage.entityEntry': 'entrada de {type}',
  'community.threadPage.sampleNotice': 'Mostrando discusión de muestra mientras despierta el foro en directo.',
  'community.threadPage.openingPostBy': 'Mensaje de apertura de {author}',
  'community.threadPage.repliesHeading': 'Respuestas',
  'community.threadPage.noReplies': 'Sin respuestas aún. Sé el primero en responder la llamada.',
  'community.threadPage.addYourReply': 'Añade tu respuesta',
} as const
